import { createStore } from 'redux';
const initailState = {
    dataList: '',
    priceItems: [],
    searchResult: 0
}
const rootReducer = (state = initailState, action) => {
    switch (action.type) {
        case 'ADD_DATA':
            return {
                ...state,
                dataList: action.payload
            }
        case 'PRICE_LIST':
            return {
                ...state,
                priceItems: action.payload
            }
        case 'SEARCH_RESULT':
            return {
                ...state,
                searchResult: action.payload
            }
        default:
            return state;
    }
}

export default createStore(rootReducer);